<div class="header">
    <div class="header-media" *ngIf="icon">
        <ng-content class="header-media-object" select="fui-icon"></ng-content>
    </div>
    <div class="header-label">
        <div class="header-label-title" id="empty-label">
            {{title | translate}}
        </div>
    </div>
</div>
<div class="description">
    <div class="description-label">
        <div class="description-label-title" id="empty-description">
            {{description | translate}}
        </div>
    </div>
</div>
